import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ModalContent = styled('div')({
    padding: '8px 32px 32px 32px',
});

export const HeaderText = styled('div')({
    marginBottom: 8,
});

export const DescriptionText = styled('div')({
    marginBottom: 24,
});

export const ActionsContainer = styled(Grid)(({ theme }) => ({
    padding: '8px 32px 0 32px',
    [theme.breakpoints.down('xs')]: {
        padding: '0',
    },
    '& button': {
        width: '160px',
        [theme.breakpoints.down('xs')]: {
            width: '100px',
        },
    },
}));
